// extracted by mini-css-extract-plugin
module.exports = {"conversationPanel":"Conversation__conversationPanel__w13W3"};